import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {useLocation} from 'react-router-dom'

import {
    Divider,
    Flex
} from '@salesforce/retail-react-app/app/components/shared/ui'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import Link from '../../components/link'
import {colors, languageAliases} from '../../constants'
import {getPathWithLocale} from '../../utils/url'
import './LanguageSelector.scss'

export const LanguageSelector = () => {
    const location = useLocation()
    const [selectedLocale, setSelectedLocale] = useState(
        languageAliases.en.localeName
    )

    const {buildUrl} = useMultiSite()

    const switchLocale = useCallback(
        (locale) => {
            localStorage?.setItem('locale', languageAliases[locale].locale)
            const newUrl = getPathWithLocale(
                languageAliases[locale.toLowerCase()].locale,
                buildUrl,
                {
                    disallowParams: ['refine']
                }
            )
            window.location = newUrl
            setSelectedLocale(locale)
        },
        [languageAliases]
    )

    useEffect(() => {
        if (location.pathname.match(languageAliases.fr.path)) {
            setSelectedLocale(languageAliases.fr.localeName)
        }
    }, [location])

    const isENSelected = useMemo(
        () => languageAliases.en.localeName === selectedLocale.toLowerCase(),
        [selectedLocale]
    )

    const isFRSelected = useMemo(
        () => languageAliases.fr.localeName === selectedLocale.toLowerCase(),
        [selectedLocale]
    )

    const btnStyles = (isSelected) => ({
        padding: '10px',
        width: '26px',
        height: '26px',
        minWidth: '26px',
        minHeight: '26px',
        textTransform: 'uppercase',
        font: 'Raleway',
        color: colors.black,
        fontWeight: isSelected ? '400' : '300',
        fontSize: '16px',
        backgroundColor: 'none',
        background: 'none',
        border: 'none',
        _hover: {
            background: 'none',
            backgroundColor: 'none'
        },
        opacity: isSelected ? 1 : 0.7,
        textDecoration: isSelected ? 'underline' : 'none',
        textUnderlineOffset: isSelected ? '5px' : 'unset'
    })

    return (
        <Flex
            gap="8px"
            alignItems="center"
            justifyContent="center"
            flexDirection="row"
            fontFamily="Raleway"
            height={{xl: '20px'}}
            marginLeft={{xl: '24px'}}
            marginRight={{xl: '0px'}}
        >
            <Link
                type="tertiary"
                onLinkClick={() => switchLocale(languageAliases.en.localeName)}
                buttonStyles={btnStyles(isENSelected)}
                inactive={!isENSelected}
                text="en"
            />
            <Divider
                display={{base: 'none', xl: 'block'}}
                orientation="vertical"
                height="16px"
                fontWeight="400"
                color="black"
                border="1px solid black"
            />
            <Link
                type="tertiary"
                onLinkClick={() => switchLocale(languageAliases.fr.localeName)}
                buttonStyles={btnStyles(isFRSelected)}
                inactive={!isFRSelected}
                text="fr"
            />
        </Flex>
    )
}
